export default {
  apiUrl: process.env.API_URL,
  intercomId: process.env.INTERCOM_ID,
  sentryDSN: process.env.SENTRY_DSN
}



// WEBPACK FOOTER //
// ./src/config.js